import { ExamOverviewType } from '../../api/exam';
import Segment from '../shared/segment';
import Field from '../shared/field';

export type ExamHeaderPropsType = {
  exam: ExamOverviewType;
};

function ExamHeader({ exam }: ExamHeaderPropsType) {
  return (
    <Segment bg noMargin color='green' className='grid gap-2 md:grid-cols-3'>
      <Field title='نام آزمون' content={exam.name} className='md:text-center' />
      <Field title='تعداد سوالات' content={exam.questionCount} className='md:text-center' />
      <Field
        title='نمره منفی'
        content={exam.penalty ? 'دارد' : 'ندارد'}
        className='md:text-center'
      />
    </Segment>
  );
}

export default ExamHeader;
